<template>
  <section id="client-information-form-agent-section">
    <v-card-title class="font-weight-medium primary--text">
      Configuración de Agentes
    </v-card-title>
    <agents-row
      v-for="(row, idx) in agentsArr"
      :row="row"
      :key="row.id"
      :showAdd="idx === 0"
      :showDelete="idx !== 0"
      :onAdd="handleAddRow"
      :onDelete="handleDeleteRow"
      @data:change="(data) => handleChangeRowFields(row.id, data)"
    ></agents-row>
  </section>
</template>

<script>
import AgentsRow from "./AgentsRow.vue";
export default {
  props: {
    agentsArr: {
      type: Array,
    },
  },

  components: {
    AgentsRow,
  },

  methods: {
    autogenerateId() {
      return Math.floor(1000 + Math.random() * 9000);
    },

    /**
     * Dispatch the change event with the new Array
     *
     * @param newArr {Array} updated array
     *
     */
    changePayload(newArr) {
      this.$emit("agent:change", newArr);
    },

    /**
     * Update the row with the given data
     *
     * @param rowId {Number} id of the row to be updated
     * @param newData {Object} updated data
     * @param newData.field {string} name of the field to be updated
     * @param newData.value {string} new value
     *
     */
    handleChangeRowFields(rowId, { field, value }) {
      const newArr = this.agentsArr.map((el) => (el.id === rowId ? { ...el, [field]: value } : el));
      this.changePayload(newArr);
    },

    /**
     * Create a new row with an autogenerated ID
     */
    handleAddRow() {
      const newArr = [...this.agentsArr, { id: this.autogenerateId(), name: "", email: "", role: "" }];
      this.changePayload(newArr);
    },

    /**
     * Remove the row of the given id
     */
    handleDeleteRow(id) {
      const newArr = this.agentsArr.filter((el) => el.id !== id);
      this.changePayload(newArr);
    },
  },
};
</script>

<style></style>
